import { type ValueOf } from '@models/helpers/custom'

export const SecuritySettingsScreens = {
  MENU: 'menu',
  PORTAL_IP_MANAGEMENT: 'portalIpManagement',
  API_IP_MANAGEMENT: 'apiIpManagement'
} as const

export type SecuritySettingsScreenType = ValueOf<typeof SecuritySettingsScreens>
